const translations = {
  deleteGroup: 'DELETE GROUP',
  addToGroup: 'ADD TO GROUP',
  error: 'Error',
  invalidUser: `User doesn't exists. Please, check user id.`,
};

export default translations;
